import {atom} from "jotai";
export const plantillasEnvioDocumentosAtom = atom([]);
export const verDocumentoAtom = atom(false);
export const plantillaSeleccionadaAtom=atom(undefined);
export const plantillasDocumentosListadasAtom=atom([]);